(function () {
  'use strict';

  function initProductCarousel(sectionId) {
    var section = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!section) return;

    var track = section.querySelector('.home-carousel__track');
    var viewport = section.querySelector('.home-carousel__viewport');
    var cards = section.querySelectorAll('.home-carousel__card');
    if (!track || !viewport || cards.length === 0) return;

    var autoSlideEnabled = section.dataset.autoSlide === 'true';
    var interval = (parseInt(section.dataset.slideInterval, 10) || 10) * 1000;
    var visibleCount = parseInt(section.dataset.visibleCount, 10) || 4;
    var autoSlideTimer = null;
    var currentIndex = 0;

    var MOBILE_BP = 767;
    var mqMobile = window.matchMedia('(max-width: ' + MOBILE_BP + 'px)');

    function isMobile() {
      return mqMobile.matches;
    }

    function getEffectiveVisible() {
      return isMobile() ? 2 : visibleCount;
    }

    var minStep = Math.min(2, visibleCount);  // smallest possible step (mobile=2, desktop=visibleCount)
    if (cards.length <= minStep) {
      return;
    }

    function getStepWidth() {
      var card = cards[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 8;
      return card.offsetWidth + gap;
    }

    function getStep() {
      return isMobile() ? 2 : visibleCount;
    }

    function getMaxIndex() {
      return Math.max(0, cards.length - getEffectiveVisible());
    }

    function getMaxOffset() {
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    }

    function slideTo(index) {
      var maxIndex = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      var stepWidth = getStepWidth();
      var targetOffset = Math.min(currentIndex * stepWidth, getMaxOffset());
      track.style.transform = 'translateX(-' + targetOffset + 'px)';
    }

    function slideNext() {
      var step = getStep();
      var maxIndex = getMaxIndex();
      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex = Math.min(currentIndex + step, maxIndex);
      }
      slideTo(currentIndex);
    }

    function startAutoSlide() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!autoSlideEnabled) return;
      stopAutoSlide();
      autoSlideTimer = setInterval(slideNext, interval);
    }

    function stopAutoSlide() {
      if (autoSlideTimer) {
        clearInterval(autoSlideTimer);
        autoSlideTimer = null;
      }
    }

    section.addEventListener('mouseenter', stopAutoSlide);
    section.addEventListener('mouseleave', function () {
      if (!isDragging) startAutoSlide();
    });

    startAutoSlide();

    /* ---- Drag to scroll ---- */

    var isDragging = false;
    var dragStartX = 0;
    var dragStartTranslate = 0;
    var dragDelta = 0;
    var dragMoved = false;

    function getCurrentTranslate() {
      var transform = track.style.transform;
      if (!transform || transform === 'none') return 0;
      var match = transform.match(/translateX\((-?[\d.]+)px\)/);
      return match ? parseFloat(match[1]) : 0;
    }

    var activePointerId = null;

    function onDragStart(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = e.clientX;
      dragStartTranslate = getCurrentTranslate();
      dragDelta = 0;
      activePointerId = e.pointerId;
      track.classList.add('is-dragging');
      stopAutoSlide();
      if (typeof viewport.setPointerCapture === 'function') {
        try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
    }

    function onDragMove(e) {
      if (!isDragging) return;
      if (activePointerId !== null && e.pointerId !== activePointerId) return;
      dragDelta = e.clientX - dragStartX;
      if (Math.abs(dragDelta) > 5) dragMoved = true;
      var newTranslate = dragStartTranslate + dragDelta;
      var maxTranslate = -getMaxOffset();
      newTranslate = Math.max(maxTranslate, Math.min(0, newTranslate));
      track.style.transform = 'translateX(' + newTranslate + 'px)';
    }

    function onDragEnd(e) {
      if (!isDragging) return;
      if (e && activePointerId !== null && e.pointerId !== activePointerId) return;
      isDragging = false;
      activePointerId = null;
      track.classList.remove('is-dragging');
      var stepWidth = getStepWidth();
      var finalTranslate = dragStartTranslate + dragDelta;
      var snappedIndex = Math.round(-finalTranslate / stepWidth);
      slideTo(snappedIndex);
      startAutoSlide();
    }

    viewport.addEventListener('pointerdown', onDragStart);
    viewport.addEventListener('pointermove', onDragMove);
    viewport.addEventListener('pointerup', onDragEnd);
    viewport.addEventListener('pointercancel', onDragEnd);

    viewport.addEventListener('click', function (e) {
      if (dragMoved) e.preventDefault();
    }, true);

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        slideTo(currentIndex);
      }, 150);
    });

    section._carouselCleanup = function () {
      stopAutoSlide();
      viewport.removeEventListener('pointerdown', onDragStart);
      viewport.removeEventListener('pointermove', onDragMove);
      viewport.removeEventListener('pointerup', onDragEnd);
      viewport.removeEventListener('pointercancel', onDragEnd);
    };
  }

  function initAll() {
    document.querySelectorAll('.home-carousel').forEach(function (el) {
      var sectionId = el.dataset.sectionId;
      if (sectionId) initProductCarousel(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.home-carousel');
    if (el) {
      var sectionId = el.dataset.sectionId;
      if (sectionId) initProductCarousel(sectionId);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('.home-carousel');
    if (el && el._carouselCleanup) el._carouselCleanup();
  });
})();
